<template>
  <div class="relative-position">
    <AppCard
      body-class="flex column"
      header-color="bg-grey-11"
      :title="$t('title.myProfile')"
      bordered
    >
      <q-form
        ref="form"
        class="q-pa-lg"
        greedy
      >
        <div class="border-bottom q-pb-lg q-gutter-y-md fields">
          <AppInput
            v-model="profile.firstName"
            :rules="[rules.REQUIRED]"
            :disable="loading"
            :label="$t('label.firstName')"
            class="flex justify-between"
            hide-bottom-space
          />
          <AppInput
            v-model="profile.lastName"
            :rules="[rules.REQUIRED]"
            :disable="loading"
            :label="$t('label.lastName')"
            class="flex justify-between"
            hide-bottom-space
          />
        </div>
        <div class="q-pt-lg">
          <AppButton
            full-width
            text-color="black"
            :label="$t('button.save')"
            :loading="loading"
            :disabled="isMasquerade"
            @click="save"
          />
        </div>
      </q-form>
    </AppCard>
    <div class="page-hint">
      {{ $t('text.profileDataHint') }}
    </div>
  </div>
</template>

<script>
import AppCard from 'common/components/AppCard';
import AppInput from 'common/components/AppInput';
import AppButton from 'common/components/buttons/AppButton';
import handleError from 'common/helpers/handleError';
import rules from 'common/helpers/rules';
import { masqueradeMixin } from 'common/mixins';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'MyDataPage',
  components: {
    AppInput,
    AppButton,
    AppCard,
  },
  mixins: [masqueradeMixin],
  data() {
    return {
      profile: undefined,
      loading: false,
    };
  },
  computed: {
    ...mapState('app', ['account']),
    rules: () => rules,
  },
  created() {
    this.profile = { ...this.account };
  },
  methods: {
    ...mapActions('app', ['updateIdentity']),
    async save() {
      try {
        const isValid = await this.$refs.form.validate();
        if (!isValid || this.isMasquerade) {
          return;
        }
        this.loading = true;
        const { firstName, lastName, currentLanguage: locale } = this.profile;
        await this.updateIdentity({
          firstName,
          lastName,
          locale,
        });
      } catch (error) {
        handleError(error);
        this.profile = { ...this.account };
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .q-card {
  width: $form-width;
}
</style>
